// src/admin/AdminRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function AdminRoute({ children }) {
  const loc = useLocation();
  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("bb_user"));
  } catch {
    user = null;
  }

  // not logged in -> go login, and remember where to come back
  if (!user?.token) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  // Superadmins use the same console, with additional approval actions.
  const role = String(user.role || "").toLowerCase();
  if (role !== "admin" && role !== "superadmin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
